import { render, staticRenderFns } from "./TagSearchPage.vue?vue&type=template&id=1f4dbf9f&scoped=true&"
import script from "./TagSearchPage.vue?vue&type=script&lang=ts&"
export * from "./TagSearchPage.vue?vue&type=script&lang=ts&"
import style0 from "./TagSearchPage.vue?vue&type=style&index=0&id=1f4dbf9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4dbf9f",
  null
  
)

export default component.exports